import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar19Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar19 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar19Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar19">
        <G id="Group">
          <Path
            id="background"
            d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
            fill={c.background}
          />
          <Path
            id="skin"
            d="M172.907 47.454c-79.022-1.112-61.531 76.163-61.332 78.507-16.237-3.225-18.374 8.388-17.58 17.523 3.075 35.548 31.704 26.826 31.735 24.196 2.566 6.029-4.678 46.2-5.449 53.278-2.105 19.342-24.91 28.644-24.91 28.644s54.762 41.315 88.729 50.609a150.844 150.844 0 0 0 17.841-5.029c16.149-6.831 9.874-42.371-18.048-48.082-3.28-.675-.31-22.051.366-33.991 8.348 1.589 17.126 4.012 23.481-2.335 6.609-13.846 21.924-41.179 22.623-53.309.453-7.856-.89-10.811-.89-25.197.691-46.867-18.977-84.29-56.558-84.822l-.008.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector"
            opacity={0.75}
            d="M182.988 232.389c.763-7.015 2.685-19.367 2.272-19.454-22.584-5.052-37.366-14.314-42.744-19.295 0 .461 12.876 33.164 40.472 38.749Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_2"
            opacity={0.75}
            d="M177.864 175.196c.715.858 10.367 16.316 22.449 16.681 10.295.31 14.513-11.494 14.807-12.09 0 0-4.147-5.545-7.308-5.64-3.162-.095-5.505 1.605-5.505 1.605s-2.685-2.248-6.045-2.352c-3.36-.103-6.498 1.772-9.683 2.169-3.218.397-8.715-.381-8.715-.381v.008Zm4.163 2.669c-.08-.064 0-.175.095-.127 3.71 1.938 10.287 3.558 20.63 3.868 5.33.159 8.857.223 11.859-.723-3.002 1.216-7.117 4.798-12.431 4.639-10.375-.317-16.539-4.933-20.153-7.665v.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_3"
            opacity={0.75}
            d="M194.991 161.993c-.612 2.383 2.335 3.964 12.439 3.559 8.325-.334 11.01-4.846 9.374-5.481-1.637-.636-3.821 2.208-9.246 2.208-7.904 0-11.964-2.661-12.575-.278l.008-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_4"
            d="M147.956 120.941s12.941-4.068 22.997-3.996c11.82.087 20.129 7.999 22.401 3.948.723-1.287.23-8.055-21.321-10.271-9.643-.993-15.315 3.535-24.084 10.319h.007Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M189.232 136.55c-2.915-4.989-7.753-9.58-13.822-10.692-2.733-.318-5.497-.016-8.102.993-2.129.81-3.766 2.16-5.346 3.511-2.137 1.477-4.973.913-7.547.611 2.431 1.7 6.021 3.059 8.976 1.605.699-.453 1.383-.85 2.058-1.2-.024.215-.048.429-.048.644 0 3.964 3.321 7.173 7.427 7.173 4.107 0 7.42-3.209 7.42-7.173 0-.326-.032-.644-.072-.953 2.908 1.334 5.839 3.312 9.048 5.481h.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M229.084 113.816c-14.131-.421-22.274 7.411-20.756 10.326.937 1.803 3.82 1.875 5.949-.159 5.831-5.004 9.318-3.328 15.427-3.415-.111-2.129-.413-4.973-.62-6.752Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M235.201 132.935c-1.573-1.35-3.217-2.693-5.346-3.511-2.598-1.009-5.37-1.319-8.103-.993-6.068 1.112-10.906 5.712-13.821 10.692 1.652-1.112 3.225-2.176 4.758-3.13.286 3.488 3.296 6.228 6.974 6.228 3.869 0 6.998-3.026 6.998-6.768 0-1.271-.381-2.446-1.008-3.463 2.502.278 5.163 1.247 8.11 3.153 2.955 1.462 6.546.096 8.976-1.604-2.573.302-5.409.866-7.546-.612l.008.008Z"
            fill="#000"
          />
          <G id="Group_2" fill="#000">
            <Path
              id="Vector_8"
              d="M245.504 271.328a71612.417 71612.417 0 0 1-52.205-20.55c10.581 5.879 11.447 31.679 9.382 44.151a151.48 151.48 0 0 0 42.823-23.601Z"
            />
            <Path
              id="Vector_9"
              d="M46.979 261.645c27.254 26.031 64.184 42.021 104.855 42.021 11.685 0 23.068-1.326 33.99-3.82-36.611-9.596-84.519-52.364-84.519-52.364s-40.282 11.303-54.326 14.171v-.008Z"
            />
          </G>
          <Path
            id="hair"
            d="M162.398 38.447c-15.355-4.901-54.565-1.31-78.42 46.724-19.89 40.051-33.87 142.563-37.97 175.529a154.856 154.856 0 0 0 7.666 6.966c19.049-7.443 62.278-25.117 65.582-33.506 4.25-10.779 8.142-66.408 8.007-68.211-.135-1.803-14.679 12.432-25.03-22.115-5.1-12.876 19.923-20.049 24.617 1.533 1.16 5.322 6.498-22.424 5.72-23.854-.771-1.438 17.094-7.896 26.348-21.885 9.255-13.988 21.138-25.197 36.843-33.315-.429-3.471-17.222-18.04-17.222-18.04s51.768 29.248 50.037 80.905c-.699 17.476 1.326 21.535.802 29.153-1.668 7.904-17.905 44.897-21.67 51.22-3.591 6.037-22.759 3.456-22.759 3.456l-4.059 32.751 63.827 25.324s10.454-16.991 8.166-63.39c-2.288-46.398-2.614-185.26-90.509-169.245h.024Z"
            fill={c.hair}
          />
        </G>
      </G>
    </Svg>
  );
};
